import type { ContactResult } from "@/lib/contacts/types";

export type TrainingContactsPanelProps = {
  organizationId?: string | null;
  locationId?: string | null;
  locationName?: string;
  presetQuery?: string | null;
};

export type ScopeFilter = "all" | "org" | "manufacturer" | "platform";
export type SourceFilter = "all" | "user" | "external";
export type LocationScope = "current" | "all";
export type TrustOverride = "auto" | "1" | "2" | "3";

export const TRAINING_CONTACTS_SEARCH_LIMIT = 30;

export function hasDirectContactInfo(c: ContactResult): boolean {
  return Boolean(
    (c.phone && c.phone.trim()) || (c.personEmail && c.personEmail.trim()) || (c.email && c.email.trim()),
  );
}

export function contactCardLabel(c: ContactResult): string {
  if (c.name && c.name.trim()) return `${c.name}${c.title ? ` — ${c.title}` : ""}`;
  return [c.company, c.location].filter((x) => String(x || "").trim()).join(" — ") || "Contact";
}

export function contactEmail(c: ContactResult): string {
  return String(c.personEmail || c.email || "").trim();
}

/** Stable unique topic labels for UI chips (directory / path-search `topics`). */
export function normalizedContactTopics(c: ContactResult): string[] {
  const raw = c.topics ?? [];
  const set = new Set<string>();
  for (const t of raw) {
    const s = String(t ?? "").trim();
    if (s) set.add(s);
  }
  return [...set].sort((a, b) => a.localeCompare(b));
}
